import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "personal",
  "use": "personal-usage",
  "viewBox": "0 0 62 62",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 62 62\" id=\"personal\">\r\n  <circle cx=\"31\" cy=\"31\" r=\"28\" fill=\"#ffffff\" stroke=\"#c2c7c9\" stroke-width=\"5\" />\r\n  <circle cx=\"31\" cy=\"22.15\" r=\"9.74\" fill=\"#28809d\" />\r\n  <path d=\"M31.44,53.13a23,23,0,0,1-19-10c.1-6.15,12.69-9.51,19-9.51s18.94,3.36,19,9.51A23,23,0,0,1,31.44,53.13Z\" fill=\"#28809d\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol